// components
import { PageTemplate } from '@/pwa/templates/PageTemplate/PageTemplate';
import { PageHeader } from '@/pwa/atoms/PageHeader/PageHeader';
import {
  SquiggleCard,
  SquiggleColor,
} from '@/pwa/atoms/SquiggleCard/SquiggleCard';

// mui
import { Stack } from '@mui/material';

const SQUIGGLE_COLORS: SquiggleColor[] = ['cherry', 'lime', 'warmOrange'];
const colorAt = (i: number): SquiggleColor =>
  SQUIGGLE_COLORS[i % SQUIGGLE_COLORS.length];

export interface CarePageCategory {
  id: string;
  title: string;
  progress: number | undefined;
  onClick: () => void;
}

export interface CarePageProps {
  onManage: () => void;
  promoted?: CarePageCategory[];
  categories: CarePageCategory[];
  fullWidthCategories?: CarePageCategory[];
}

/**
 * CarePage is the care page showing a care circle card and action plan
 * category cards with progress.
 */
export const CarePage = ({
  onManage,
  promoted,
  categories,
  fullWidthCategories,
}: CarePageProps) => {
  return (
    <PageTemplate
      headerSlot={
        <PageHeader
          title='Care profile'
          description='Manage your care circle and access your KareHero documents.'
        />
      }
      contentSlot={
        <Stack spacing={2}>
          <SquiggleCard
            squiggleColor='lime'
            title='Care circle'
            subtitle='Manage the people assisting in your care circle.'
            chevron
            onClick={onManage}
          />
          <Stack spacing={1}>
            {promoted?.map((category, i) => (
              <SquiggleCard
                key={category.id}
                variant='compact'
                squiggle={false}
                squiggleColor={colorAt(i)}
                title={category.title}
                progress={category.progress}
                chevron
                onClick={category.onClick}
              />
            ))}
            {categories.map((category, i) => (
              <SquiggleCard
                key={category.id}
                variant='compact'
                squiggle={false}
                squiggleColor={colorAt(i + 1)}
                title={category.title}
                progress={category.progress}
                chevron
                onClick={category.onClick}
              />
            ))}
            {fullWidthCategories?.map((category, i) => (
              <SquiggleCard
                key={category.id}
                variant='compact'
                squiggle={false}
                squiggleColor={colorAt(i + 2)}
                title={category.title}
                progress={category.progress}
                chevron
                onClick={category.onClick}
              />
            ))}
          </Stack>
        </Stack>
      }
    />
  );
};

CarePage.displayName = 'CarePage';

export default CarePage;
